import { Blockquote as TiptapBlockquote } from "@tiptap/extension-blockquote";

import { ActionButton } from "../../components";

export const Blockquote = TiptapBlockquote.extend({
	addOptions() {
		return {
			...this.parent?.(),
			HTMLAttributes: {
				class: "blockquote"
			},
			button: ({ editor, t }) => ({
				component: ActionButton,
				componentProps: {
					action: () => editor.commands.toggleBlockquote(),
					isActive: () => editor.isActive("blockquote") || false,
					icon: "TextQuote",
					shortcutKeys: ["shift", "mod", "B"],
					tooltip: t("editor.blockquote.tooltip")
				}
			})
		};
	}
});
